import React from 'react';
import { Body, Divider, Grid } from '@walmart-web/livingdesign-components';

import styles from './styles.module.css';
import NotificationItem, {
  NotificationItemType
} from './NotificationItem/index.tsx';

type Props = {
  label: string;
  data: NotificationItemType[];
};

const NotificationsSection: React.FC<Props> = ({
  label,
  data,
  ...restProps
}) => {
  return (
    <Grid UNSAFE_className={styles.sectionContainer}>
      <Body size="medium" UNSAFE_className={styles.notificationSectionLabel}>
        {label}
      </Body>
      {data.map((notification) => (
        <NotificationItem
          key={notification.id}
          {...notification}
          {...restProps}
        />
      ))}
      <Divider />
    </Grid>
  );
};

export default NotificationsSection;
